import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ControlInterface } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Dispatch } from 'redux';
import ContactsTable from './ContactsTable';
import { toggleModal } from '../../../../ModalTest/actions';
import Modal from '../../../../ModalTest';
import Button from '../../../../Button';

interface ContactsModalProps extends ControlInterface, ReduxComponentInterface {
  formInstanceId: string;
  params: any;
  view: boolean;
  index: number;
}

class ContactsModal extends window.React.PureComponent<ContactsModalProps> {
  onClose = (event?: React.MouseEvent) => {
    event && event.preventDefault();
    const { actions, name, formInstanceId } = this.props;
    actions.toggleModal(false, name, null, formInstanceId);
  };

  render() {
    const { name, value, formInstanceId, index, view } = this.props;
    return (
      <Modal
        className={'contacts-modal'}
        hideActionButtons
        onClose={this.onClose}
        name={name}
        reducerPath={[formInstanceId, 'formModal']}
        title={window.Alfresco.messages.global['edocat.forms.contacts']}
      >
        <div className="modal-body react-root table-modal">
          <ContactsTable {...{ formInstanceId, index, view, value, name }} />
        </div>
        <div className="modal-actions">
          <Button label={window.Alfresco.messages.global['button.close']} onClick={this.onClose} />
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(null, mapDispatchToProps)(ContactsModal);
